import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export function SkeletonLoader() {
    return (
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-5 mb-4">
            <div className="flex items-start">
                <Skeleton circle width={48} height={48} className="mr-4" />
                <div className="flex-1">
                    <Skeleton height={24} width="60%" className="mb-2" />
                    <Skeleton height={16} width="40%" className="mb-2" />
                    <Skeleton height={16} width="80%" className="mb-2" />
                    <Skeleton height={12} width="30%" />
                </div>
            </div>
            <div className="mt-4 flex gap-2">
                <Skeleton width={60} height={24} />
                <Skeleton width={60} height={24} />
            </div>
        </div>
    )
}